import { AuthGuard, PermissionGuard } from '@abp/ng.core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { identityEntityPropContributors } from './identity-config/entity-prop-contributors';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboards/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(m => m.IdentityModule.forLazy({
      entityPropContributors: identityEntityPropContributors,
    })),
  },
  {
    path: 'language-management',
    loadChildren: () =>
      import('@volo/abp.ng.language-management').then(m => m.LanguageManagementModule.forLazy()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(m => m.SaasModule.forLazy()),
  },
  {
    path: 'audit-logs',
    loadChildren: () =>
      import('@volo/abp.ng.audit-logging').then(m => m.AuditLoggingModule.forLazy()),
  },
  {
    path: 'identity-server',
    loadChildren: () =>
      import('@volo/abp.ng.identity-server').then(m => m.IdentityServerModule.forLazy()),
  },
  {
    path: 'text-template-management',
    loadChildren: () =>
      import('@volo/abp.ng.text-template-management').then(m =>
        m.TextTemplateManagementModule.forLazy()
      ),
  },
  {
    path: 'setting-management',
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
  },

  { path: 'galleries', loadChildren: () => import('./galleries/gallery-list/gallery-list.module').then(m => m.GalleryListModule) },
  { path: 'galleries/:id', loadChildren: () => import('./galleries/gallery-edit/gallery-edit.module').then(m => m.GalleryEditModule) },
  { path: 'user-galleries', loadChildren: () => import('./user-galleries/user-gallery-list/user-gallery-list.module').then(m => m.UserGalleryListModule) },
  { path: 'user-galleries/:id', loadChildren: () => import('./user-galleries/user-gallery-edit/user-gallery-edit.module').then(m => m.UserGalleryEditModule) },
  { path: 'artworks', loadChildren: () => import('./artworks/artwork-list/artwork-list.module').then(m => m.ArtworkListModule) },
  { path: 'artworks/:id', loadChildren: () => import('./artworks/artwork-edit/artwork-edit.module').then(m => m.ArtworkEditModule) },


{ path: 'user-artworks', loadChildren: () => import('./user-artworks/user-artwork-list/user-artwork-list.module').then(m => m.UserArtworkListModule) },
{ path: 'user-artworks/:id', loadChildren: () => import('./user-artworks/user-artwork-edit/user-artwork-edit.module').then(m => m.UserArtworkEditModule) },

  { path: 'comments', loadChildren: () => import('./comments/comment-list/comment-list.module').then(m => m.CommentListModule) },
  //  { path: 'comments/:id', loadChildren: () => import('./comments/comment.module').then(m => m.CommentModule) },
  { path: 'categories', loadChildren: () => import('./categories/category-list/category-list.module').then(m => m.CategoryListModule) },
  { path: 'categories/:id', loadChildren: () => import('./categories/category-edit/category-edit.module').then(m => m.CategoryEditModule) },
  { path: 'rev-share-periods', loadChildren: () => import('./ledgers/rev-share-period-list/rev-share-period-list.module').then(m => m.RevSharePeriodListModule) },
  { path: 'rev-share-periods/:id', loadChildren: () => import('./ledgers/rev-share-period-edit/rev-share-period-edit.module').then(m => m.RevSharePeriodEditModule) },
  { path: 'public-api-clients', loadChildren: () => import('./api-clients/api-client-list/api-client-list.module').then(m => m.ApiClientListModule) },
  { path: 'public-api-clients/:id', loadChildren: () => import('./api-clients/api-client-edit/api-client-edit.module').then(m => m.ApiClientEditModule) },
  { path: 'my-api-access', loadChildren: () => import('./my-api-access/my-api-access-list/my-api-access.module').then(m => m.MyApiAccessModule) },
  { path: 'ledger-items', loadChildren: () => import('./ledgers/ledger-item-list/ledger-item-list.module').then(m => m.LedgerItemListModule) },
  { path: 'offers', loadChildren: () => import('./products/offer-list/offer-list.module').then(m => m.OfferListModule) },
  { path: 'offers/:id', loadChildren: () => import('./products/offer-edit/offer-edit.module').then(m => m.OfferEditModule) },
  { path: 'receipts', loadChildren: () => import('./products/receipt-list/receipt-list.module').then(m => m.ReceiptListModule) },
  { path: 'receipts/:id', loadChildren: () => import('./products/receipt-edit/receipt-edit.module').then(m => m.ReceiptEditModule) },
  { path: 'flags', loadChildren: () => import('./flags/flags-list/flag-list.module').then(m => m.FlagListModule) },
  { path: 'notifications', loadChildren: () => import('./notifications/notification.module').then(m => m.NotificationModule) },
  { path: 'topicnotifications', loadChildren: () => import('./notifications/topic-notifications/topic-notification.module').then(m => m.TopicNotificationModule) },
  { path: 'caches', loadChildren: () => import('./caches/cache-list.module').then(c => c.CacheListModule) },
  { path: 'share/user/:userId', loadChildren: () => import('./user-share/user-share.module').then(m => m.UserShareModule) },
  { path: 'share/gallery/:galleryId', loadChildren: () => import('./gallery-share/gallery-share.module').then(m => m.GalleryShareModule) },
  { path: 'share/artwork/:artworkId', loadChildren: () => import('./artwork-share/artwork-share.module').then(m => m.ArtworkShareModule) },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
